import { NAME } from './constants';

export const SAVE_TEMPLATES_TABLE = `${NAME}/SAVE_TEMPLATES_TABLE`;
export const RESET = `${NAME}/RESET`;
export const SHOW_ALL_TEMPLATES = `${NAME}/SHOW_ALL_TEMPLATES`;
